import React, { useState } from "react";
import { Button, Col, Form, OverlayTrigger, Popover } from "react-bootstrap";
import { toast } from "react-toastify";
import ExcelIcon from "../../assets/svg/excelIcon.svg";
import {viewSIDoc, updateSIDoc } from "../../services/tractorDataService";

function SIDocCard({ info }) {
  const [updatedSI, setUpdatedSI] = useState([]);

  const handleSIDocUpdate = async () => {
    try {
      if (updatedSI.length !== []) {
        var formData = new FormData();
        formData.append("_files", updatedSI);
        await updateSIDoc(info.SIDocumentId, formData);
        toast.success("SI document updated successfully");
      } else toast.warn("Please select new SI file");
    } catch (error) {
      setUpdatedSI([]);
      toast.success("Unable to update SI");
    }
  };

  async function viewSIDocHandler() {
    try {
      const response = await viewSIDoc(info.DocName)
      const link = document.createElement("a");
      link.href = response.data.Message;
      link.download = info.DocName;
      link.click();
    } catch (error) {
      toast.error('Unable to download SI Document')
    }
  }

  return (
    <>
      <div className="col-sm-6 col-md-6 col-lg-4 doc-card">
        <div className="card-si bg-white p-3 shadow">
          <div className="d-flex justify-content-between">
            <div className="user-info">
              <img src={ExcelIcon} alt="PDF" className="doc-card-icon" />
              <div style={{ marginRight: "16px" }}>
                <h6 className="mb-1">{"Special Instructions"}</h6>
                <p className="text-muted mb-0">
                  {updatedSI.length !== 0 ? updatedSI.name : info.DocName}
                </p>
              </div>
            </div>
            <div className="action-icon">
              <span className="card-icon-dwn" onClick={viewSIDocHandler}>
                {/* <a
                  href={
                    updatedSI.length !== 0
                      ? updatedSI
                      : siDocPath + info.DocName
                  }
                  download
                > */}
                  <i className="fi fi-rr-download"></i>
                {/* </a> */}
              </span>
              <OverlayTrigger
                trigger="click"
                placement={"left"}
                overlay={
                  <Popover>
                    <Popover.Header as="h3">Select new file</Popover.Header>
                    <Popover.Body>
                      <Form.Group as={Col}>
                        <Form.Control
                          type="file"
                          className="file-modal-input"
                          name="siFiles"
                          onChange={(e) => {
                            if (e.target.files.length > 0) {
                              setUpdatedSI(e.target.files[0]);
                            } else {
                              setUpdatedSI([]);
                            }
                          }}
                        />
                      </Form.Group>
                      <Button
                        style={{
                          marginTop: "10px",
                          float: "right",
                        }}
                        size="sm"
                        onClick={handleSIDocUpdate}
                      >
                        Upload
                      </Button>
                    </Popover.Body>
                  </Popover>
                }
              >
                <span className="card-icon-rec">
                  <i className="fi fi-rr-refresh"></i>
                </span>
              </OverlayTrigger>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SIDocCard;
